
export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    description: { type: String, default: '' },
    name: { type: String, required: true },
    required: { type: Boolean, required: false, default: () => false },
    errorMessage: { type: String },
    inputType: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      showError: false,
      error: undefined,
    };
  },
  computed: {
    inputName() {
      return this.label.toLowerCase();
    },
    inputId() {
      return `forminput-${this.label.toLowerCase().replace(' ', '-')}`;
    },
  },
  watch: {
    showError(val) {
      if (val) {
        // use errormessage from input if one exists, else
        // use default
        this.error = this.errorMessage ? this.errorMessage : this.error;
      }
    },
  },
  methods: {
    onBlur() {
      switch (this.inputType) {
        case 'tel':
          this.showError = !new RegExp('^[0-9]*$').test(this.value);
          break;
        case 'email':
          this.handleEmail(this.value);
          break;
        default:
          if (this.required) {
            this.showError = !this.value || this.value === '';
          } else {
            this.showError = undefined;
          }
      }
    },
    handleEmail(input) {
      if ((input === '' || input === undefined) && !this.required) {
        this.showError = false;
        return;
      }
      const showEmailError = !new RegExp(
        '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-.]+\\.[a-zA-Z0-9-.]+$'
      ).test(input.trim());
      if (showEmailError) {
        this.showError = true;
        this.error = 'Beklager, men det er noe funky med denne adressen.';
      } else {
        this.showError = false;
      }
    },
  },
};
